import { ReactNode } from 'react';
import Box from '@mui/material/Box';

interface MainTableRowActionsProps {
  children: ReactNode;
}

function MainTableRowActions({ children }: MainTableRowActionsProps) {
  return (
    <Box display="flex" alignItems="center" gap={1} justifyContent="flex-end">
      {children}
    </Box>
  );
}

export default MainTableRowActions;
